(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.localesReady) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-locale-tab]'));
    var media = Array.prototype.slice.call(root.querySelectorAll('[data-locale-media]'));
    var addressEl = root.querySelector('[data-locale-address]');
    var addressBag = root.querySelector('[data-locale-addresses]');
    var addresses = addressBag
      ? (addressBag.getAttribute('data-locale-addresses') || '').split('|')
      : [];
    if (!tabs.length) return;

    root.dataset.localesReady = '1';

    var current = 0;

    function select(index, moveFocus) {
      current = index;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        // Roving tabindex: only the selected city is a tab stop, so the
        // group is one stop in the page order rather than three.
        tab.tabIndex = on ? 0 : -1;
      });
      media.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      // one address line, rewritten rather than three stacked
      if (addressEl && addresses[index] !== undefined) {
        addressEl.textContent = addresses[index];
      }
      if (moveFocus) tabs[index].focus();
    }

    /* ---------------- auto-rotation ----------------
       One rAF loop against an absolute deadline, rather than a setTimeout
       chain with pause/resume bookkeeping.

       The previous version subtracted elapsed time on pause and re-armed with
       the remainder, which meant any pause — the pointer crossing the section
       as the page scrolls under it, the observer flickering across its
       threshold — changed how long the next step lasted. Here the deadline is
       a wall-clock instant: nothing accumulates, and a frame the browser was
       too busy to serve is corrected on the next one rather than added on.

       Never runs under reduced motion — a backdrop cross-fading on its own is
       exactly the unrequested movement that setting exists to suppress. */
    var interval = parseInt(root.dataset.localesAutoplay || '0', 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canPlay = interval > 0 && tabs.length > 1 && !reduce;

    var stopped = false;   // the visitor chose a city — never rotate again
    var nextAt = 0;
    var raf = null;

    // Pause reasons tracked one by one. Four independent things can want this
    // held — the pointer, focus, a hidden tab, being off screen — and with a
    // single flag the mouse leaving would restart it while the tab was still
    // in the background.
    var pausedBy = {};
    function heldBack() {
      for (var k in pausedBy) { if (pausedBy[k]) return true; }
      return false;
    }
    function pauseFor(reason) { pausedBy[reason] = true; }
    function resumeFrom(reason) { pausedBy[reason] = false; }

    var debug = /(^|[?&])localesdebug\b/.test(location.search);
    var lastHop = 0;

    function loop(now) {
      raf = requestAnimationFrame(loop);
      if (stopped) return;

      /* While held, the deadline is pushed along with the clock, so releasing
         gives a clean full interval rather than an instant jump from a
         countdown that expired while nobody was looking. */
      if (heldBack()) { nextAt = now + interval; return; }

      if (now >= nextAt) {
        if (debug && lastHop) console.log('[locales] step', Math.round(now - lastHop), 'ms');
        lastHop = now;
        select((current + 1) % tabs.length, false);
        nextAt = now + interval;
      }
    }

    /* A deliberate selection ends the rotation for good rather than pausing
       it. Resuming would drag the visitor off the city they just chose a
       couple of seconds later, which reads as the page fighting them. */
    function stopForGood() {
      stopped = true;
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        stopForGood();
        select(i, false);
      });

      tab.addEventListener('keydown', function (e) {
        var last = tabs.length - 1;
        var next = null;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;

        if (next !== null) {
          e.preventDefault();
          stopForGood();
          select(next, true);
        }
      });
    });

    if (canPlay) {
            /* Hover pause is scoped to the backdrop itself, not the whole section —
         crossing the heading or the padding above it should not hold the
         rotation. mouseenter/mouseleave do not bubble, so binding here fires
         only on this element's own boundary.

         Guarded to devices that can genuinely hover: touch fires mouseenter on
         tap and frequently never fires the matching mouseleave, which left the
         rotation held for the rest of the session. */
      var hoverZone = root.querySelector('.luxe-locales__media');
      if (hoverZone && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        hoverZone.addEventListener('mouseenter', function () { pauseFor('hover'); });
        hoverZone.addEventListener('mouseleave', function () { resumeFrom('hover'); });
      }


      root.addEventListener('focusin', function () { pauseFor('focus'); });
      root.addEventListener('focusout', function () { resumeFrom('focus'); });

      // Off screen it does nothing, so the sequence begins when the section is
      // actually scrolled to. No visibilitychange handler is needed: rAF does
      // not run in a background tab at all.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) resumeFrom('offscreen');
          else pauseFor('offscreen');
        }, { threshold: 0.15 }).observe(root);
      }
    }

    // Whatever the markup shipped as active stays active — no reset on load.
    var start = tabs.findIndex(function (t) { return t.classList.contains('is-active'); });
    select(start < 0 ? 0 : start, false);

    if (canPlay) {
      nextAt = performance.now() + interval;
      raf = requestAnimationFrame(loop);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-locales]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  } else {
    initAll();
  }

  // The theme editor tears a section down and rebuilds it on every change, so
  // the fresh markup needs wiring up again — the guard flag above lives on the
  // element and is discarded with it.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
